export const casingTypes = {
  UPPERCASE: 'Uppercase',
  LOWERCASE: 'Lowercase',
  NONE: 'None',
} as const
